import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogNavigationService {

  navigateToItem = new EventEmitter<string>();

  navigateToCategory = new EventEmitter<string>();

  constructor() { }

  clickItem(itemId: string) {
    this.navigateToItem.emit(itemId);
  }

  clickCategory(categoryId: string) {
    this.navigateToCategory.emit(categoryId);
  }
}
